export const ReasonVI = {
    "decisionReason": {
        "title": "Tạo mới lý do",
        "label": {
            "reason": "Lý do",
            "status": "Trạng thái"
        },
        "placeholder": {
            "reason": "Nhập lý do"
        },
        "option": {
            "active": "Hoạt động",
            "inActive": "Không hoạt động"
        },

    }
}